module.exports = __webpack_public_path__ + "img/mckayla-crump-675004-unsplash-edit.a57c4ed4.webp";